import {ForwardedRef, forwardRef} from "react";
import {components, OptionProps, SelectInstance, SingleValueProps} from "react-select";

import {Select} from "@/components/select/Select.tsx";
import {SelectProps} from "@/components/select/Select.types.ts";
import {ComponentStatus} from "@/lib/types/statuspages.ts";
import ComponentStatusIcon from "@/pages/statuspages/tabs/components/ComponentStatusSelect/ComponentStatusIcon.tsx";

const ComponentStatusSingleValue = ({data, selectProps, ...props}: SingleValueProps<ComponentStatus>) => (
  <components.SingleValue {...props} data={data} selectProps={selectProps}>
    <div className="d-flex align-items-center">
      <ComponentStatusIcon className="me-2" status={data.value} disabled={selectProps.isDisabled} />
    </div>
  </components.SingleValue>
);

const ComponentStatusOption = ({data, ...props}: OptionProps<ComponentStatus>) => (
  <components.Option {...props} data={data}>
    <div className="d-flex align-items-center">
      <ComponentStatusIcon className="me-2" status={data.value} />
    </div>
  </components.Option>
);

const ComponentStatusSelect = forwardRef(
  (props: SelectProps<ComponentStatus>, ref: ForwardedRef<SelectInstance<ComponentStatus>>) => {
    return (
      <Select
        ref={ref}
        isSearchable={false}
        getOptionValue={(c) => c.value}
        getOptionLabel={(c) => c.display}
        components={{Option: ComponentStatusOption, SingleValue: ComponentStatusSingleValue}}
        {...props}
      />
    );
  }
);

export default ComponentStatusSelect;
